<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--right" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="icon-arrow-right-title">
  <title id="icon-arrow-right-title">Arrow Right</title>
  <path d="M2.68.667.601 1.9l8.222 4.892 1.513.875-1.513.874-8.222 4.892 2.077 1.233 11.79-7-11.79-7Z"/>
</svg></template>